import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import Entities from 'STORE';

import { Avatar, AvatarTypes } from '../Avatar';
import { AvatarWithFullScreen } from '../AvatarWithFullScreen/AvatarWithFullScreen';

interface IWorkspaceAvatarProps {
  className?: string;
  type?: AvatarTypes;
  withFullScreen?: boolean;
}

export const WorkspaceAvatar: FC<IWorkspaceAvatarProps> = observer(
  ({ className, type = AvatarTypes.Square_20, withFullScreen }) => {
    const workspace = Entities.workspace;

    const avatar = (
      <Avatar
        className={className}
        type={type}
        title={workspace.name}
        url={workspace.avatarUrl}
        backgroundColorIndex={workspace.avatarColorIndex}
      />
    );

    if (withFullScreen) {
      return (
        <AvatarWithFullScreen
          className={className}
          url={workspace.avatarUrl || ''}
        >
          {avatar}
        </AvatarWithFullScreen>
      );
    }

    return avatar;
  }
);
